<div class="celo-toolbar g-10px flex justify-between">
  @if (!isSelecting) {
    <div class="toolbar-button">
      <button
        mat-button
        class="celo-secondary-button"
        [attr.aria-label]="'Select ' + pageName.toLowerCase()"
        (click)="start()"
      >
        <div class="flex items-center">
          @if (pageName === "Media") {
            <mat-icon>photo</mat-icon>
          }
          @if (pageName === "Documents") {
            <mat-icon svgIcon="icon-documents-consents"></mat-icon>
          }
          @if (pageName === "Consents") {
            <mat-icon svgIcon="icon-documents-consents"></mat-icon>
          }
          <span class="text">
            Select <span class="lowercase">{{ pageName }}</span>
          </span>
        </div>
      </button>
    </div>
  }

  @if (isSelecting) {
    <div class="toolbar-tools">
      <button mat-button (click)="cancel()">Cancel</button>
      <span class="sep">|</span>
      @if (!singleFileDownloadUrl) {
        <button
          [matTooltip]="'Download ' + pageName.toLowerCase()"
          mat-icon-button
          (click)="onAction('download')"
        >
          <i class="material-icons">file_download</i>
        </button>
      }
      @if (singleFileDownloadUrl) {
        <a
          [matTooltip]="'Download ' + singleFileType"
          [href]="singleFileDownloadUrl | secure"
          [download]="singleFileName"
          (click)="$event.stopPropagation()"
        >
          <button mat-icon-button>
            <i class="material-icons">file_download</i>
          </button>
        </a>
      }
      @if (pageName !== "Consents") {
        <button
          [matTooltip]="'Share ' + pageName.toLowerCase()"
          mat-icon-button
          [attr.aria-label]="'Share ' + pageName.toLowerCase()"
          (click)="onAction('share')"
        >
          <i class="material-icons">share</i>
        </button>
      }
      @if (pageName !== "Consents") {
        <button
          [matTooltip]="'Delete ' + pageName.toLowerCase()"
          mat-icon-button
          [attr.aria-label]="'Delete ' + pageName.toLowerCase()"
          (click)="onAction('delete')"
        >
          <i class="material-icons">delete</i>
        </button>
      }
    </div>
  }

  @if (
    !hideExportToClinicalRecord &&
    !isSelecting &&
    (isPhotoExportEnabled$ | async)
  ) {
    <div class="toolbar-button">
      <button mat-button class="celo-secondary-button" (click)="export()">
        <div class="flex items-center">
          <mat-icon svgIcon="ic-emr-red"></mat-icon>
          <span class="text">Export to clinical record </span>
        </div>
      </button>
    </div>
  }
</div>
